import React from "react";
import CarriersSliderComponent from "./carriers-slider.component";

const CarrierSlider = () => {
  return <CarriersSliderComponent />;
};

export default CarrierSlider;
